/* istanbul ignore file */
/* It's not possible to fill VGS fields in Cypress */

import makeApi, { ResponsePostprocessing } from '@lib/api'

export interface Request {
  reservation_id: number
  marketing_carrier_code: string
  retailer_partner_number: string
  payment_method: string
  card_details?: {
    card_number: string
    card_expiry: string
    card_expiry_year: string
    card_expiry_month: string
    security_code: string
    card_holder_name: string
    card_type: string
  }
}

export interface CustomField {
  id: string
  name: string
  value: string
}

export interface Response {
  id: string
  reservationId: string
  totalPrice: Money
  currency: string
  fees: Fee[]
  customFields: CustomField[]
}

const config: ResponsePostprocessing = {
  convertValues: {
    totalPrice: 'Price',
    originalPrice: 'Price',
    amount: 'Price',
  },
}

export const checkCardApi = async (body: Request): Promise<Response> => {
  const url = `/reservations/${body.reservation_id}/payment_details`

  const callApi = makeApi.post<{}, Request, Response>(
    {
      type: 'reservations',
      old: url,
      new: url,
    },
    {
      responsePostprocessing: config,
    },
  )

  return await callApi({ body, params: {} })
}
